/**
 * Harvest Mate - OEM Connection API
 *
 * Contact: servicedesk@clevvi.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { UnmappedEventsResponse } from '../model/unmapped-events-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class OemUnmappedEventsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * List unresolved &#x60;oem_unlinked_events&#x60; for the calling tenant.
     * Returns the count of unresolved parked events plus the most recent &#x60;limit&#x60; rows (default 10, capped at 50). Driven by SRA003-116\&#39;s &#x60;oem_unlinked_events&#x60; parking table — the FE counter banner reads &#x60;count&#x60; to surface the per-tenant unmapped-events backlog and the deep-link target for the click-through.  **Scoping (per architect ruling 73979):** - Contractor: filters on &#x60;oem_unlinked_events.contractor_id &#x3D;   caller\&#39;s contractor_id&#x60;. Returns only &#x60;field_unmapped&#x60; rows   because &#x60;contractor_id&#x60; is NULL on &#x60;machine_unmapped&#x60; / &#x60;both&#x60;   rows by construction (machine half didn\&#39;t resolve, so no   harvester → no owner). Index &#x60;(contractor_id, resolved_at)&#x60;   is load-bearing here. - Admin: unscoped — sees all reasons. - Other roles: &#x60;403 forbidden&#x60;. 
     * @endpoint get /oem-connection/unmapped-events
     * @param limit Max number of &#x60;recent&#x60; items to return. Default 10; capped at 50. Out-of-range or non-integer values silently clamp to the default per existing pagination convention. 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listUnmappedEvents(limit?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<UnmappedEventsResponse>;
    public listUnmappedEvents(limit?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<UnmappedEventsResponse>>;
    public listUnmappedEvents(limit?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<UnmappedEventsResponse>>;
    public listUnmappedEvents(limit?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'limit',
            <any>limit,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/unmapped-events`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<UnmappedEventsResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
